module.exports = __webpack_public_path__ + "static/media/speak_directly.b2cb65fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/speak_directly.svg
// module id = 1411
// module chunks = 0